module.exports = __webpack_public_path__ + "img/yilian_normal.8b8a3535.png";